import { IOnchangeFieldHelper } from '../models/IOnchangeFieldHelper'

interface IRange {
  start: number
  end: number
}
interface IOnChangeRangedFieldArgs extends IOnchangeFieldHelper<number> {
  range: IRange
}

export const onChangeRangedField =
  ({ onChange, range }: IOnChangeRangedFieldArgs) =>
  (value: string) => {
    if (Number(value) > range.end || Number(value) < range.start) {
      return
    }
    onChange(Number(value))
  }
